import { ref } from "vue";
import { useEventListener } from "./useEventListener.es.js";
function useElementHover(target) {
  const isHovered = ref(false);
  useEventListener(target, "mouseenter", () => isHovered.value = true);
  useEventListener(target, "mouseleave", () => isHovered.value = false);
  return isHovered;
}
export {
  useElementHover
};
//# sourceMappingURL=useElementHover.es.js.map
